import React, { useEffect, useState } from 'react'
 
import { useMutation } from 'react-query'
import { toast } from 'react-toastify'

import { postContracts } from '../../../../MyApi/hr/contracts'

import PageHeader from '../../../../Components/UI/PageHeader'
import AddConstracts from '../../../../Components/hr/constracts/constractsStore/AddConstracts'


const ConstractsStore = () => {
const [sb_company_id ,setCompanyId]= useState("")
const [selectedCompany, setSelectedCompany]=useState("")
const [hr_designation_id, setHr_designation_id] =useState("")
const [selectedDesignation , setSelectedDesignation]=useState("")
const [selectedLevel , setSelectedLevel]=useState("")
const [selectedBranch , setSelectedBranch] =useState("")
const [selectedDepartment , setSelectedDepartment]=useState("")
const [selectedCurrency ,setSelectedCurrency] =useState("")
const [hr_level_id ,setLevelId] =useState("")
const [description, setDescription] = useState("")
const [active ,setActive] = useState(1)
const [start_date,setStart_date] =useState("")
const [duration ,setDuration] =useState("")
const [duration_type ,setDurationType]=useState("")
const [end_date , setEnd_date]=useState("")
const [join_date, setJoin_date]=useState("")
const [signing_date ,setSigningDate]= useState("")
const [intership ,setInterShip] =useState(1)
const [internship_end_date ,setInterShipEndDate] =useState("")
const [paid_period , setPaidPeriod] =useState("")
const [status ,setStatus] = useState("")
const [salaryComponentObject ,setSalaryComponentObject] =useState({})
const [sb_currency_id, setCurrencyId] =useState("")
const [total ,setTotal]=useState(0)
const [sb_branch_id ,setBranchId]=useState("")
const [sb_department_id,setDepartmentId]=useState("")
const [sb_employe_id, setEmployId]= useState("")
const [rows,setRows] =useState([{id:0}])

useEffect(()=>{
  if(intership ===0){
    setInterShipEndDate(null)
  }
},[intership])
 const mutation = useMutation("postconstracts" , (postData)=>postContracts(postData) ,{
    onSuccess:(data)=>{
        toast.success(`${data.message}`)
        setDescription("")
        setStart_date("")
        setDuration("")
        setEnd_date("")
        setJoin_date("")
        setSigningDate("")    
        setInterShipEndDate("")
        setPaidPeriod("")
        setStatus("")
  

    },
    onError:(error)=>{
        toast.error(`${error.response.data.message}`)
    }
 })
 let hr_salary_component_ids =[];
 let amounts = [];

 const handleAddRow = () => {
    setRows([...rows, { id: rows.length }]);
  };
  const handleRemoveRow =( RowId )=>{
    setRows(rows.filter((row)=>row.id !== RowId ))
    setSalaryComponentObject(
     {
      ...salaryComponentObject ,
      [RowId]:null
     }
    )
  }

Object.values(salaryComponentObject).forEach((item)=>{
  if(item!==null){
    hr_salary_component_ids.push(item.id);
    amounts.push(item.amount);
  }

})
 const handlePostRequest =()=>{
    mutation.mutate({
        sb_company_id,
        active,
        hr_designation_id,
        hr_level_id,
        start_date,
        duration,
        duration_type,
        end_date,
        join_date,
        signing_date,
        intership,
        internship_end_date,
        paid_period,
        status,
        hr_salary_component_ids,
        amounts,
        sb_currency_id,
        total,
        sb_employe_id,
        sb_branch_id,
        sb_department_id
    })
 }
 const isDisabled= ()=>{
    return !(sb_company_id && description &&  hr_designation_id&&
      hr_level_id&&
      start_date&&
      duration&&
      duration_type&&
      end_date&&
      join_date&&
      signing_date&&
      paid_period&&
      status&&
      hr_salary_component_ids&&
      amounts&&
      sb_currency_id&&
      total&&
      sb_employe_id&&
      sb_branch_id&&
      sb_department_id)
  
 }
  return ( 

    <div>
        <PageHeader title="Add Constracts"  showBack={true} saveButton={true} isdisbled={isDisabled} handlePostRequest={handlePostRequest} />
        <AddConstracts companyId={sb_company_id} branchId={sb_branch_id}    setRows={setRows} setEmployId={setEmployId} signing_date={signing_date} join_date={join_date} end_date={end_date}  duration_type={duration_type} duration={duration}   start_date={start_date}   description={description} setSelectedDesignation={setSelectedDesignation} selectedLevel={selectedLevel} selectedCompany={selectedCompany}  selectedDesgintions={selectedDesignation} selectedBranch={selectedBranch} selectedDepartment={selectedDepartment}  setSelectedBranch={setSelectedBranch} setSelectedLevel={setSelectedLevel} setSelectedDepartment={setSelectedDepartment} selectedCurrency={selectedCurrency} setSelectedCompany={setSelectedCompany}   setSelectedCurrency={setSelectedCurrency}   intership={intership}   handleRemoveRow={handleRemoveRow}  salaryComponentObject={salaryComponentObject} setDepartmentId={setDepartmentId} handleAddRow={handleAddRow} rows={rows}  setTotal={setTotal} setBranchId={setBranchId}   setCurrencyId={setCurrencyId}  setSalaryComponentObject={setSalaryComponentObject}  setPaidPeriod={setPaidPeriod} setStatus={setStatus}  setJoin_date={setJoin_date} setSigningDate={setSigningDate} setInterShipEndDate={setInterShipEndDate}  setInterShip={setInterShip} setHr_designation_id={setHr_designation_id} setLevelId={setLevelId} setStart_date={setStart_date}    setCompanyId={setCompanyId} setDescription={setDescription}  setActive={setActive} active={active} setDuration={setDuration} setDurationType={setDurationType}  setEnd_date={setEnd_date}/>
    </div>
  )
}

export default ConstractsStore